import type { CSSProperties, ReactNode } from 'react';
import { Icon } from './Icon';

interface FieldProps {
  label: ReactNode;
  hint?: ReactNode;
  error?: string | null;
  required?: boolean;
  children: ReactNode;
  style?: CSSProperties;
  htmlFor?: string;
}

export function Field({ label, hint, error, required, children, style, htmlFor }: FieldProps) {
  return (
    <label htmlFor={htmlFor} style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      <span
        style={{
          fontSize: 12.5,
          fontWeight: 500,
          color: 'var(--bx-text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        {label}
        {required && <span style={{ color: 'var(--bx-error)' }}>*</span>}
      </span>
      {children}
      {error ? (
        <span
          style={{
            fontSize: 11.5,
            color: 'var(--bx-error)',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
          }}
        >
          <Icon name="warning" size={11} />
          {error}
        </span>
      ) : hint ? (
        <span style={{ fontSize: 11.5, color: 'var(--bx-text-muted)' }}>{hint}</span>
      ) : null}
    </label>
  );
}
